import { Injectable } from '@angular/core';
import { CountryCode, Provinces, State, States } from '@interface/location';

@Injectable()
export class LocationService {
  public getStates(countryCode: CountryCode): State[] {
    return { [CountryCode.US]: States, [CountryCode.CA]: Provinces }[countryCode];
  }
}
